/*
 *
 * File JS icon text slider
 *
 */

// IMPORT COMPONENTI
//--------------------------------------------------------------------//
import Swiper from "swiper/bundle";
//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import "./icon-text-list.scss";

//--------------------------------------------------------------------//

// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const iconTextList = () => {
    let allIconTextList = document.querySelectorAll(".icon-text-list");

    if (!allIconTextList.length) return;
};

export default iconTextList;

//--------------------------------------------------------------------//
